import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout/Layout';
import LandingPage from './pages/LandingPage';
import CodeBySkilloraLandingPage from './pages/CodeBySkilloraLandingPage';
import HybridJavaOnlineCompilerPage from './pages/HybridJavaOnlineCompilerPage';
import HybridRunJavaCodeOnlinePage from './pages/HybridRunJavaCodeOnlinePage';
import HybridJavaPlaygroundPage from './pages/HybridJavaPlaygroundPage';
import ReusableCodeExecutor from './components/ReusableCodeExecutor';
import JavaOnlineCompilerPage from './pages/JavaOnlineCompilerPage';
import RunJavaCodeOnlinePage from './pages/RunJavaCodeOnlinePage';
import JavaPlaygroundPage from './pages/JavaPlaygroundPage';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Main Landing Page */}
          <Route path="/" element={<LandingPage />} />
          
          {/* Code by Skillora Pages */}
          <Route path="/skillora" element={<CodeBySkilloraLandingPage />} />
          
          {/* Hybrid SEO Pages */}
          <Route path="/java-online-compiler" element={<HybridJavaOnlineCompilerPage />} />
          <Route path="/run-java-code-online" element={<HybridRunJavaCodeOnlinePage />} />
          <Route path="/java-playground" element={<HybridJavaPlaygroundPage />} />
          
          {/* Code Executor App */}
          <Route path="/app" element={
            <Layout>
              <div className="app-home">
                <ReusableCodeExecutor />
              </div>
            </Layout>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
